/**
 * @generated SignedSource<<b8ef439b68a5b45ad49bb9d7da0c626d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReviewerTemplateCardPaginationFragment_templateFlows$data = {
  readonly flows: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly rowId: UUID;
        readonly " $fragmentSpreads": FragmentRefs<"TemplateFavorite_flow">;
      };
    }>;
    readonly totalCount: number;
  } | null | undefined;
  readonly " $fragmentType": "ReviewerTemplateCardPaginationFragment_templateFlows";
};
export type ReviewerTemplateCardPaginationFragment_templateFlows$key = {
  readonly " $data"?: ReviewerTemplateCardPaginationFragment_templateFlows$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReviewerTemplateCardPaginationFragment_templateFlows">;
};

import ReviewerTemplateCardTemplateFlowsPaginationQuery_graphql from './ReviewerTemplateCardTemplateFlowsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "flows"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "flowFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "gwtUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ReviewerTemplateCardTemplateFlowsPaginationQuery_graphql
    }
  },
  "name": "ReviewerTemplateCardPaginationFragment_templateFlows",
  "selections": [
    {
      "alias": "flows",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "flowFilter"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "CREATED_AT_DESC"
        }
      ],
      "concreteType": "FlowsConnection",
      "kind": "LinkedField",
      "name": "__ReviewerTemplateCard_flows_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FlowsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Flow",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "gwtUserId",
                      "variableName": "gwtUserId"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "TemplateFavorite_flow"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "de3909dfb3b3f7c2d2f600089b236df6";

export default node;
